import "./styles.scss"

import React from "react"

type Props = {
  variant: "main" | "light" | "dark" | "mono" | "bordered"
  lang: "en" | "pl"
}

const WebinityBadge = ({ variant = "main", lang = "en" }: Props) => {
  const URL = `https://webinity.zenx.pl/wp-content/themes/webinity-cms/assets/badges/badge-${variant}_${lang}.svg`

  return (
    <span className="webinity-badge">
      <a
        href={`http://webinity.com/${lang === "pl" ? "pl/" : ""}`}
        target="_blank"
        rel="noreferrer"
      >
        <img src={URL} alt="Webinity" />
      </a>
    </span>
  )
}

export default WebinityBadge
